import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useNavigate } from 'react-router-dom';

const PopularRoutes = ({ currentLanguage }) => {
  const navigate = useNavigate();

  const content = {
    en: {
      title: "Popular Routes & Prices",
      viewAll: "View All Prices",
      bookNow: "Book Now",
      routes: [
        { from: "Thong Sala Pier", to: "Haad Rin", price: "300-400", time: "15-20 min" },
        { from: "Thong Sala", to: "Haad Yao", price: "250-350", time: "10-15 min" },
        { from: "Airport", to: "Thong Sala", price: "400-500", time: "20-25 min" },
        { from: "Haad Rin", to: "Bottle Beach", price: "450-550", time: "25-30 min" }
      ]
    },
    ru: {
      title: "Популярные Маршруты и Цены",
      viewAll: "Все Цены",
      bookNow: "Забронировать",
      routes: [
        { from: "Пирс Тонг Сала", to: "Хаад Рин", price: "300-400", time: "15-20 мин" },
        { from: "Тонг Сала", to: "Хаад Яо", price: "250-350", time: "10-15 мин" },
        { from: "Аэропорт", to: "Тонг Сала", price: "400-500", time: "20-25 мин" },
        { from: "Хаад Рин", to: "Боттл Бич", price: "450-550", time: "25-30 мин" }
      ]
    },
    th: {
      title: "เส้นทางยอดนิยมและราคา",
      viewAll: "ดูราคาทั้งหมด",
      bookNow: "จองเดินทาง",
      routes: [
        { from: "ท่าเรือทองศาลา", to: "หาดริ้น", price: "300-400", time: "15-20 นาที" },
        { from: "ทองศาลา", to: "หาดยาว", price: "250-350", time: "10-15 นาที" },
        { from: "สนามบิน", to: "ทองศาลา", price: "400-500", time: "20-25 นาที" },
        { from: "หาดริ้น", to: "หาดขวด", price: "450-550", time: "25-30 นาที" }
      ]
    },
    de: {
      title: "Beliebte Routen & Preise",
      viewAll: "Alle Preise Anzeigen",
      bookNow: "Jetzt Buchen",
      routes: [
        { from: "Thong Sala Pier", to: "Haad Rin", price: "300-400", time: "15-20 Min" },
        { from: "Thong Sala", to: "Haad Yao", price: "250-350", time: "10-15 Min" },
        { from: "Flughafen", to: "Thong Sala", price: "400-500", time: "20-25 Min" },
        { from: "Haad Rin", to: "Bottle Beach", price: "450-550", time: "25-30 Min" }
      ]
    },
    fr: {
      title: "Itinéraires et Prix Populaires",
      viewAll: "Voir Tous les Prix",
      bookNow: "Réserver",
      routes: [
        { from: "Quai de Thong Sala", to: "Haad Rin", price: "300-400", time: "15-20 min" },
        { from: "Thong Sala", to: "Haad Yao", price: "250-350", time: "10-15 min" },
        { from: "Aéroport", to: "Thong Sala", price: "400-500", time: "20-25 min" },
        { from: "Haad Rin", to: "Bottle Beach", price: "450-550", time: "25-30 min" }
      ]
    },
    zh: {
      title: "热门路线和价格",
      viewAll: "查看所有价格",
      bookNow: "立即预订",
      routes: [
        { from: "通萨拉码头", to: "哈德林", price: "300-400", time: "15-20分钟" },
        { from: "通萨拉", to: "哈德尧", price: "250-350", time: "10-15分钟" },
        { from: "机场", to: "通萨拉", price: "400-500", time: "20-25分钟" },
        { from: "哈德林", to: "瓶子海滩", price: "450-550", time: "25-30分钟" }
      ]
    },
    es: {
      title: "Rutas y Precios Populares",
      viewAll: "Ver Todos los Precios",
      bookNow: "Reservar Ahora",
      routes: [
        { from: "Muelle Thong Sala", to: "Haad Rin", price: "300-400", time: "15-20 min" },
        { from: "Thong Sala", to: "Haad Yao", price: "250-350", time: "10-15 min" },
        { from: "Aeropuerto", to: "Thong Sala", price: "400-500", time: "20-25 min" },
        { from: "Haad Rin", to: "Bottle Beach", price: "450-550", time: "25-30 min" }
      ]
    },
    ja: {
      title: "人気のルートと料金",
      viewAll: "すべての料金を表示",
      bookNow: "今すぐ予約",
      routes: [
        { from: "トンサラー桟橋", to: "ハードリン", price: "300-400", time: "15-20分" },
        { from: "トンサラー", to: "ハードヤオ", price: "250-350", time: "10-15分" },
        { from: "空港", to: "トンサラー", price: "400-500", time: "20-25分" },
        { from: "ハードリン", to: "ボトルビーチ", price: "450-550", time: "25-30分" }
      ]
    },
    ko: {
      title: "인기 노선 및 요금",
      viewAll: "모든 요금 보기",
      bookNow: "지금 예약",
      routes: [
        { from: "통살라 부두", to: "하드린", price: "300-400", time: "15-20분" },
        { from: "통살라", to: "하드야오", price: "250-350", time: "10-15분" },
        { from: "공항", to: "통살라", price: "400-500", time: "20-25분" },
        { from: "하드린", to: "보틀 비치", price: "450-550", time: "25-30분" }
      ]
    }
  };

  const currentContent = content?.[currentLanguage] || content?.en;

  return (
    <section className="py-16 sm:py-20 lg:py-24 px-4 sm:px-6 lg:px-8 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground">
            {currentContent?.title}
          </h2>
          <Button
            variant="outline"
            onClick={() => navigate('/route-price-list')}
            iconName="List"
            iconPosition="left"
          >
            {currentContent?.viewAll}
          </Button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {currentContent?.routes?.map((route, index) => (
            <div key={index} className="morphic-card p-6 hover:shadow-xl transition-all duration-300 group">
              <div className="flex items-start justify-between mb-4">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-3 h-3 rounded-full bg-accent" />
                    <span className="text-lg font-semibold text-foreground">{route?.from}</span>
                  </div>
                  <div className="h-8 w-0.5 bg-border ml-1.5 mb-2" />
                  <div className="flex items-center gap-3">
                    <div className="w-3 h-3 rounded-full bg-success" />
                    <span className="text-lg font-semibold text-foreground">{route?.to}</span>
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-2xl font-bold text-accent mb-1">
                    ฿{route?.price}
                  </div>
                  <div className="text-sm text-muted-foreground flex items-center gap-1">
                    <Icon name="Clock" size={14} />
                    {route?.time}
                  </div>
                </div>
              </div>
              <Button
                variant="morphic"
                size="sm"
                onClick={() => navigate('/smart-booking-form')}
                iconName="Calendar"
                iconPosition="left"
                className="w-full"
              >
                {currentContent?.bookNow}
              </Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PopularRoutes;